/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconErrorFilled8 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconErrorFilled8(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 8 8" ref={ref}>
            <path
                d="M4 8a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm-.645-2.149c0-.373.283-.641.641-.641a.63.63 0 0 1 .649.641.635.635 0 0 1-.649.649.634.634 0 0 1-.641-.649ZM3.733 1.5h.534c.22 0 .392.188.374.406l-.197 2.365a.25.25 0 0 1-.249.229h-.39a.25.25 0 0 1-.25-.23L3.36 1.907a.375.375 0 0 1 .374-.406Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconErrorFilled12 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconErrorFilled12(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 12 12" ref={ref}>
            <path
                d="M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12Zm-.968-3.223c0-.56.425-.962.962-.962.548 0 .973.403.973.962 0 .56-.425.973-.973.973a.95.95 0 0 1-.962-.973ZM5.6 2.25H6.4c.33 0 .588.281.56.61l-.295 3.546a.375.375 0 0 1-.374.344h-.584a.375.375 0 0 1-.374-.344l-.296-3.547a.563.563 0 0 1 .56-.609Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconErrorFilled16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconErrorFilled16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Zm-1.29-4.297c0-.746.567-1.283 1.282-1.283.731 0 1.298.537 1.298 1.283A1.27 1.27 0 0 1 7.993 13c-.716 0-1.283-.552-1.283-1.297ZM7.465 3h1.07a.75.75 0 0 1 .747.812l-.394 4.729a.5.5 0 0 1-.498.458h-.78a.5.5 0 0 1-.498-.458l-.394-4.729A.75.75 0 0 1 7.465 3Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconErrorFilled20 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconErrorFilled20(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 20 20" ref={ref}>
            <path
                d="M10 18.333a8.333 8.333 0 1 0 0-16.666 8.333 8.333 0 0 0 0 16.666ZM8.75 14.16c0-.722.55-1.242 1.243-1.242.708 0 1.257.52 1.257 1.242 0 .723-.549 1.258-1.257 1.258a1.228 1.228 0 0 1-1.243-1.258ZM9.31 5h1.38c.237 0 .427.198.416.435l-.255 5.833a.417.417 0 0 1-.416.399h-.869a.417.417 0 0 1-.416-.399l-.256-5.833A.417.417 0 0 1 9.311 5Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconErrorFilled24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconErrorFilled24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm-1.5-5.009c0-.867.659-1.491 1.491-1.491.85 0 1.509.624 1.509 1.491 0 .867-.659 1.509-1.509 1.509-.832 0-1.491-.642-1.491-1.509ZM11.172 6h1.656a.5.5 0 0 1 .5.522l-.307 7a.5.5 0 0 1-.5.478H11.48a.5.5 0 0 1-.5-.478l-.306-7a.5.5 0 0 1 .5-.522Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconErrorFilled = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconErrorFilled(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '8':
            return <IconErrorFilled8 {...iconProps} />;
        case '12':
            return <IconErrorFilled12 {...iconProps} />;
        case '16':
            return <IconErrorFilled16 {...iconProps} />;
        case '20':
            return <IconErrorFilled20 {...iconProps} />;
        case '24':
            return <IconErrorFilled24 {...iconProps} />;
        default:
            return <IconErrorFilled24 {...iconProps} />;
    }
});
